import { getToken, getContractAddress } from 'utilities';

export const BRN_TOKEN_ID = 'brn';
export const BRN_TOKEN_ADDRESS = getToken(BRN_TOKEN_ID).address;
export const BRN_VAULT_PROXY_CONTRACT_ADDRESS = getContractAddress('brnVaultProxy');
export const BRN_DECIMAL = getToken(BRN_TOKEN_ID).decimals;
